<template>
	<module class="module-config" title="统计配置">
		<c-form ref="form" vertical unit-width="100%">
			<c-form-item label="主统计项">
				<div v-if="mainData" class="group" style="padding-top: 16px;">
					<c-form ref="mainForm" column="3" unit-width="100%">
						<c-form-item label="数据源" colspan="2" required>
							<c-select v-model="mainData.source" name="source" :options="quotaDataSource" :clear="false" @change="sourceHandle(mainData, 0)"></c-select>
						</c-form-item>
						<c-form-item label="名称" required>
							<c-input v-model="mainData.name" name="name"></c-input>
						</c-form-item>
						<c-form-item label="统计项" colspan="2" required>
							<c-select v-model="mainData.quota" name="quota" :options="mainData.quotaOptions" :clear="false"></c-select>
						</c-form-item>
						<c-form-item label="计算方式">
							<c-select v-model="mainData.computed" :options="quotaComputedOptions[quotaDataType[0]]" :clear="false"></c-select>
						</c-form-item>
						<c-form-item label="数据过滤" colspan="2">
							<data-filter ref="mainDataFilter" class="data-filter"></data-filter>
						</c-form-item>
					</c-form>
				</div>
			</c-form-item>
			<c-form-item label="子统计项">
				<template v-for="(item, i) in dataList">
					<div v-if="i" :key="i" class="group">
						<div class="group-index">{{i}}</div>
						<div class="group-handle flex">
							<a class="flex-center" @click="dataList.splice(i, 1)"><i class="tf-cross"></i></a>
						</div>
						<c-form ref="childForm" column="3" unit-width="100%">
							<c-form-item label="数据源" colspan="2" required>
								<c-select v-model="item.source" name="source" :options="quotaDataSource" :clear="false" @change="sourceHandle(item, i)"></c-select>
							</c-form-item>
							<c-form-item label="名称" required>
								<c-input v-model="item.name" name="name"></c-input>
							</c-form-item>
							<div class="flex" style="width: calc(66.6667% - 14px); gap: 10px">
								<c-form-item class="flex-grow" label="统计项" required style="width: 0;">
									<c-select v-model="item.quota" name="quota" :options="item.quotaOptions" :disabled="!item.source" :clear="false"></c-select>
								</c-form-item>
								<c-form-item label="计算方式" style="width: 200px;">
									<c-select v-model="item.computed" :options="quotaComputedOptions[quotaDataType[i]]" :disabled="!item.source" :clear="false"></c-select>
								</c-form-item>
							</div>
							<c-form-item label="颜色" required>
								<ul class="color-list flex-center-cross">
									<li v-for="(color, j) in colorList" :key="j" class="flex-center" :class="{'z-crt': item.color == color}" @click="item.color = color">
										<div :style="{'background': `var(--color-${color})`}"></div>
									</li>
								</ul>
							</c-form-item>
							<c-form-item label="数据过滤" colspan="2">
								<data-filter ref="dataFilter" class="data-filter"></data-filter>
							</c-form-item>
						</c-form>
					</div>
				</template>
				<div v-show="dataList.length < 6" class="group-add flex-center" @click="pushHandle()"><i class="tf-add"></i>添加统计项</div>
			</c-form-item>
			<c-form-item label="背景图片">
				<c-upload-file v-model="background" name="background" type="image"></c-upload-file>
			</c-form-item>
		</c-form>
	</module>
</template>

<script>
	import dataFilter from '@/components/view/data_filter.vue'
	import {getStore, mapStore} from '@deanwu/vue-component-library'

	export default {
		components: {
			dataFilter
		},

		data() {
			return {
				...getStore(this),
				dataList: [],
				colorList: ['white', 'green', 'red', 'yellow'],
				background: ''
			}
		},

		computed: {
			...mapStore(['quotaDataSource', 'quotaComputedOptions']),

			mainData() {
				return this.dataList[0];
			},

			quotaDataType() {
				return this.dataList.map(item => {
					let field = item.quotaOptions.find(field => field.value == item.quota);
					return field ? field.type : 0;
				});
			}
		},
		
		watch: {
			quotaDataSource() {
				this.init();
			}
		},

		mounted() {
			this.store.getDataSource('quota');
		},

		methods: {
			init() {
				this.$nextTick(() => {
					this.quotaDataSource.length && this.dataList.forEach((item, index) => {
						if (!item.source) {
							item.source = this.quotaDataSource[0].value;
						}
						if (!item.quotaOptions.length) {
							this.getQuota(item, index);
						}
						(index ? this.$refs.dataFilter[index - 1] : this.$refs.mainDataFilter).set(item.source, item.filter || []);
					});
				})
			},

			sourceHandle(item, index) {
				(index ? this.$refs.dataFilter[index - 1] : this.$refs.mainDataFilter).set(item.source, []);
				this.updateOptions(item);
			},

			updateOptions(item) {
				this.getQuota(item);
			},

			getQuota(item, index = 0) {
				this.store.getQuota(2, 5, item.source, data => {
					item.quotaOptions = data;
					this.$nextTick(() => {
						if (!item.quota) {
							item.quota = data[index].value;
						}
					})
				});
			},

			pushHandle(config) {
				let item = config || {
					name: '',
					source: '',
					quotaOptions: [],
					quota: '',
					computed: '',
					color: 'white'
				};

				this.dataList.push(item);

				this.$watch(() => item.source, () => {
					let oldData = item.quotaOptions.find(opt => opt.value == item.quota);
					if (!item.name.trim() || (oldData && item.name.trim() == oldData.name)) {
						item.name = '';
					}
				});

				this.$watch(() => item.quota, (val, old) => {
					let valData = item.quotaOptions.find(opt => opt.value == val);
					if (!valData) return;
					let oldData = item.quotaOptions.find(opt => opt.value == old);
					if (!item.name.trim() || (oldData && item.name.trim() == oldData.name)) {
						item.name = valData.name;
					}
				});

				this.$watch(() => item.computed, (val, old) => {
					let index = this.dataList.findIndex(temp => temp == item);
					if (!val) {
						this.$nextTick(() => {
							let oldOpt = this.quotaComputedOptions[this.quotaDataType[index]].find(item => item.value == old);
							item.computed = (oldOpt || this.quotaComputedOptions[this.quotaDataType[index]][0]).value;
						});
					}
				}, {
					immediate: true
				});
			},

			setConfig(config = {}) {
				if (config.data) {
					if (config.data.list.length) {
						config.data.list.forEach(item => {
							this.pushHandle(item);
						});
					} else {
						this.pushHandle();
					}
					this.background = config.data.background;
				} else {
					this.pushHandle();
				}
				this.init();
			},

			getConfig() {
				return new Promise(resolve => {
					Promise.all([this.$refs.mainForm].concat(this.$refs.childForm || []).map($form => {
						return new Promise(resolve => {
							$form.validate({
								rule: {
									name: '请填写名称',
									source: '请选择数据源',
									quota: '请选择统计项'
								},
								success: () => {
									resolve(true);
								},
								fail: () => {
									resolve(false);
								}
							});
						})
					})).then(data => {
						if (data.findIndex(item => item === false) == -1) {
							resolve({
								type: 4,
								data: {
									list: this.dataList.map((item, index) => {
										item.filter = (index ? this.$refs.dataFilter[index - 1] : this.$refs.mainDataFilter).get();
										return item;
									}),
									background: this.background
								}
							});
						} else {
							resolve(false);
						}
					})
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		position: relative;
		border-radius: 6px;
		padding: 22px 26px 12px 16px;
		background: #F9F9F9;

		&:nth-child(n+2) {
			margin-top: 10px;
		}

		&-index {
			position: absolute;
			left: 0;
			top: 0;
			width: 18px;
			border-radius: 6px 0 6px 0;
			line-height: 18px;
			font-size: 12px;
			text-align: center;
			color: #0081FA;
			background: #E0EDF9;
		}

		&-handle {
			position: absolute;
			right: 0;
			top: 0;

			a {
				width: 18px;
				height: 18px;
				border-radius: 0 6px 0 6px;
				font-size: 12px;
				color: #fff;
				background: #f55;
			}
		}

		&-add {
			gap: 6px;
			height: 38px;
			border: 1px dashed var(--color-main);
			border-radius: 6px;
			font-size: 14px;
			color: var(--color-main);
			cursor: pointer;

			&:hover {
				border-color: var(--color-main-hover);
				color: var(--color-main-hover);
			}

			&:nth-child(n+2) {
				margin-top: 10px;
			}
		}
	}

	.color-list {
		gap: 8px;
		padding: 2px 0;

		li {
			box-sizing: border-box;
			width: 34px;
			height: 34px;
			border: 1px solid #fff;
			border-radius: 100%;
			cursor: pointer;

			&:hover,
			&.z-crt {
				border-color: var(--color-main);
			}

			div {
				width: 22px;
				height: 22px;
				border: 1px solid #ddd;
				border-radius: 100%;
			}
		}
	}

	>>> .data-filter .filter li:nth-child(1):nth-last-child(1) {
		padding-top: 4px;
	}
</style>